module.exports = __webpack_public_path__ + "25888480b8f8dc6a10e7f298ac87a7e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/visitor/five/five-bg.jpg
// module id = 1265
// module chunks = 0